import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PhotoGrid } from "./PhotoGrid";

export const ServiceGallery = ({ svc }) => {
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    setPhotos([]);
    api.get("/photos", { params: { category: svc.categories }, paramsSerializer: { indexes: null } })
      .then((r) => setPhotos(r.data.slice(0, 6))).catch(() => {});
  }, [svc]);

  if (!photos.length) return null;
  const catalogLink = svc.categories.length === 1 ? `/catalogo?categoria=${encodeURIComponent(svc.categories[0])}` : "/catalogo";
  return (
    <section className="pb-24 max-w-[1440px] mx-auto px-5 sm:px-8" data-testid="service-gallery">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />En imágenes</p>
        <Link to={catalogLink} className="font-brand text-[11px] font-semibold tracking-[0.18em] uppercase border-b border-ink pb-1 hover:text-granate hover:border-granate transition-colors" data-testid="service-gallery-catalog-link">Ver todo el catálogo</Link>
      </div>
      <PhotoGrid photos={photos} testPrefix="service-gallery" />
    </section>
  );
};
